import React from 'react';

import { Circle, CircleOutlined, Contrast } from '@mui/icons-material';

import StlChip, { IStlChip } from 'features/common/StlChip';

type ConditionVariant = 'freeFlow' | 'moderate' | 'severe';

const chipVariants: Record<ConditionVariant, IStlChip> = {
  freeFlow: {
    label: 'Free Flow',
    icon: <CircleOutlined fontSize="small" />,
    color: {
      bg: '#252b30',
      icon: '#4E8DC2',
    },
  },
  moderate: {
    label: 'Moderate',
    icon: <Contrast fontSize="small" />,
    color: {
      bg: '#4b422d',
      icon: '#f4c75f',
    },
  },
  severe: {
    label: 'Severe',
    icon: <Circle fontSize="small" />,
    color: {
      bg: '#472d25',
      icon: '#E16136',
    },
  },
};

interface ConditionChipVariantProps {
  variant: ConditionVariant;
}

export function ConditionChip({ variant }: ConditionChipVariantProps) {
  const { icon, label, color } = chipVariants[variant];

  return <StlChip icon={icon} label={label} color={color} />;
}
